const productSetDrawerSelectors = {
  content: '[data-product-set-drawer-content]',
  title: '[data-product-set-drawer-title]',
  scrollShadow: '.product-set-drawer__scroll-shadow',
};

class ProductSetDrawer extends BaseDrawer {
  constructor() {
    const globalSelectors = {
      // No single static trigger exists yet — the Similar Styles and Shop the Look
      // triggers each call openWithTitle() directly once their own UI is built.
      triggerButton: '[data-product-set-drawer-trigger]',
      drawer: '[data-product-set-drawer]',
      overlay: '[data-product-set-drawer-overlay]',
    };
    super(globalSelectors);
  }

  connectedCallback() {
    // quick-add-inline (used inside the drawer's product cards) adds to cart
    // and opens the site's cart-drawer itself, but has no awareness of this
    // drawer — without this, both end up open/stacked after a successful add.
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      if (this.classList.contains('active')) this.close();
    });

    const content = this.querySelector(productSetDrawerSelectors.content);
    if (!content) return;

    content.addEventListener('scroll', () => this.updateScrollShadow(), { passive: true });
    window.addEventListener('resize', () => this.updateScrollShadow());

    // Content can be set synchronously (renderContent) or asynchronously
    // (Tagalys renders into a placeholder after its own fetch resolves) — a
    // mutation observer covers both without each caller needing to remember
    // to trigger the check itself.
    this.contentObserver = new MutationObserver(() => this.updateScrollShadow());
    this.contentObserver.observe(content, { childList: true, subtree: true });
  }

  /** Hides the "more to scroll" shadow once there's nothing left below the fold. */
  updateScrollShadow() {
    const content = this.querySelector(productSetDrawerSelectors.content);
    const shadow = this.querySelector(productSetDrawerSelectors.scrollShadow);
    if (!content || !shadow) return;

    const hasMoreToScroll = content.scrollTop + content.clientHeight < content.scrollHeight - 4;
    shadow.style.display = hasMoreToScroll ? '' : 'none';
  }

  /**
   * Opens the drawer with a given title and a loading state. Callers should
   * follow up with renderContent() once their product data has been fetched.
   */
  openWithTitle(title, triggeredBy) {
    this.setTitle(title);
    this.setLoading();
    this.open(triggeredBy);
  }

  setTitle(title) {
    const titleEl = this.querySelector(productSetDrawerSelectors.title);
    if (titleEl) titleEl.textContent = title;
  }

  setLoading() {
    const content = this.querySelector(productSetDrawerSelectors.content);
    if (content) {
      content.innerHTML = `<p class="paragraph--small center">${this.dataset.loadingText}</p>`;
    }
  }

  renderContent(html) {
    const content = this.querySelector(productSetDrawerSelectors.content);
    if (content) content.innerHTML = html;
  }
}

customElements.define('product-set-drawer', ProductSetDrawer);
